<template>
  <v-container>
    <v-sheet class="pa-5">
      <v-row>
        <span class="display-1">Fremmøde</span>
        <v-spacer></v-spacer>
        <span class="display-1">{{ percentage }}%</span>
      </v-row>

      <v-simple-table dense width="100%">
        <template v-slot:default>
          <thead width="100%">
            <tr>
              <th class="text-left">Navn</th>
              <th class="text-left">Mødt?</th>
              <th class="text-left">Note</th>
            </tr>
          </thead>
          <tbody width="100%">
            <tr v-for="(profile, index) in activePersons" :key="index" class="pa-8">
              <td class="pt-n0" width="200px">
                {{ profile.firstName }}
                {{ profile.lastName }} {{ attendance[profile.id] }}
                {{ attNotes[profile.id] }}
              </td>
              <td width="100px">
                <v-btn-toggle dense class="mt-n0 mb-n0" rounded v-model="attendance[profile.id]">
                  <v-btn small :value="true" active-class="green">
                    <v-icon>mdi-account-check-outline</v-icon>
                  </v-btn>
                  <v-btn v-if="false" small>
                    <v-icon>mdi-account-question-outline</v-icon>
                  </v-btn>
                  <v-btn small :value="false" active-class="red">
                    <v-icon>mdi-account-off-outline</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </td>
              <td>
                <v-text-field v-model="attNotes[profile.id]" dense class="mt-n1 mb-n2"></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
  </v-container>
</template>

<script>
import Vue2Filters from "vue2-filters";
import * as firebase from "firebase/app";
import { db } from "../main";

export default {
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      activePersons2: [{ firstName: "John", lastName: "Doe" }],
      attendance: {}, // { TYxMMS9ToURllSKisqFz: { attended: true } },
      attNotes: {}
    };
  },
  created() {
    db.collection("attendance")
      .doc("20-01-28")
      .collection("attendees")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data());
          var data = doc.data();
          this.attendance[data.id] = data.attended;
          this.attNotes[data.id] = data.note;
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },
  computed: {
    attended() {
      var newArray = [];
      var attendance = this.attendance;
      var attNotes = this.attNotes;
      if (this.activePersons) {
        this.activePersons.forEach(function(person, index) {
          var newObject = {};
          if (attNotes[index]) {
            newObject.note = attNotes[index];
          }
          if (attendance[index]) {
            newObject.attended = attendance[index];
          }
          if (newObject.attended || newObject.note) {
            newObject.id = person.id;
          }

          if (newObject.id) {
            newArray.push(newObject);
          }
        });
      }
      return newArray;
    },
    percentage() {
      if (this.activePersons) {
        var count = this.activePersons.length;

        /*      var attended = this.attendance.filter(function(number) {
          return number == true;
        });
 */
        var test = (100 / count) * 1;
        return test.toFixed(0);
      }

      return null;
    },
    classes() {
      return this.$store.state.classes;
    },
    activePersons: function() {
      if (!this.persons) {
        return null;
      }
      return this.persons.filter(function(p) {
        if (p.attended) {
          p.attended = 1;
        }
        return p.active;
      });
    },
    persons() {
      let result = [];
      if (this.classData) {
        result = this.filterBy(
          this.$store.getters.getList,
          this.classData.id,
          "class"
        );
      }

      if (result.length == 0) {
        result = null;
      }
      return result;
    },
    /* persons() {
      return this.$store.getters.getList;
    }, */
    classData() {
      if (this.classes) {
        let hold = this.classes.find(obj => {
          return obj.slug === this.$route.params.id;
        });
        return hold;
      } else {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
